import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import type { JSX } from 'react'

import { JobsScreen } from './-components/jobs-screen.tsx'
import { readJobSearch } from './-lib/jobs.ts'

/**
 * The ingestion jobs page.
 *
 * The open job is the `job` search param, read loosely. A typed
 * `validateSearch` on this route would narrow the search type of every
 * `navigate` call in the app.
 */
export const Route = createFileRoute('/platform/jobs')({
  component: JobsPage
})

function JobsPage(): JSX.Element {
  const search: Record<string, unknown> = useSearch({ strict: false })
  const jobId = readJobSearch(search)
  const navigate = useNavigate()

  return (
    <JobsScreen
      selectedJobId={jobId}
      onSelectJob={next => {
        void navigate({
          to: '.',
          search: prev => {
            const current = prev as Record<string, unknown>
            if (next === null) {
              const { job: _job, ...rest } = current

              return rest
            }

            return { ...current, job: next }
          }
        })
      }}
    />
  )
}
